export default function CareersHero() {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-brand-800 via-brand-700 to-brand-600">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="absolute right-0 top-0 w-[45%] h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-brand-800/30 to-brand-700/90"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Diverse%20Indian%20technology%20and%20operations%20team%20collaborating%20in%20a%20bright%20modern%20open%20plan%20office%20space%20with%20large%20windows%20natural%20light%2C%20people%20gathered%20around%20a%20digital%20whiteboard%20and%20standing%20desk%20discussing%20logistics%20network%20data%20on%20large%20screens%2C%20genuine%20candid%20workplace%20energy%2C%20professional%20but%20relaxed%20atmosphere%2C%20editorial%20corporate%20culture%20photography%2C%20warm%20tones%20mixed%20with%20cool%20blue%20accents&width=900&height=800&seq=freshhlock-careers-hero&orientation=portrait"
          alt="Freshhlock team collaborating in modern office"
          className="w-full h-full object-cover opacity-18"
        />
      </div>

      <div className="container-page relative z-10">
        <div className="flex flex-col lg:flex-row items-center min-h-[440px] md:min-h-[500px] py-16 md:py-20">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/30 border border-accent-400/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400"></div>
              <span className="text-xs font-medium text-accent-100 uppercase tracking-widest">
                Careers
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-paper-50 leading-tight mb-5 text-balance">
              Build India&apos;s Frozen Food Network With Us
            </h1>
            <p className="text-base md:text-lg text-brand-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              We&apos;re a team of builders, operators, and problem-solvers transforming how frozen food moves across India. If you want your work to change an industry — not just a product — you belong here.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="#open-roles"
                className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                View Open Roles
              </a>
              <a
                href="#culture"
                className="px-8 py-3.5 border border-brand-300/50 hover:border-paper-50/80 text-paper-50 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Life at Freshhlock
              </a>
            </div>
          </div>
          <div className="hidden lg:block w-2/5"></div>
        </div>
      </div>
    </section>
  );
}